/**
 * The toast for a Microsoft verify run, from the subscription banner's
 * Re-verify button on Admin › Unified Inbox — the only Re-verify control (the
 * inbox page's banner was removed in b0fec705a). Kept apart from the tab so it
 * can be tested on its own.
 *
 * A failed run lists EVERY error. Showing only `verification_errors[0]` hid
 * the degraded-subscription error behind a missing-subscription one (#368).
 */
import React from 'react';
import { toast } from 'sonner';

import { verifyErrorDetails } from './inboxRules';

export function reportVerifyResult(result) {
    if (result?.ok) {
        const count = result.mailboxes_discovered;
        toast.success(
            `Microsoft 365 connected · ${count} mailbox${count === 1 ? '' : 'es'} discovered`
        );
        return;
    }
    const details = verifyErrorDetails(result);
    if (details.length === 1) {
        toast.error(details[0]);
        return;
    }
    toast.error(`Verification found ${details.length} problems`, {
        description: (
            <ul className="list-disc pl-4 space-y-1" data-testid="verify-error-list">
                {details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                ))}
            </ul>
        ),
    });
}
